import React from "react";
import Iterator from "../utils/Iterator";
import { useTranslation } from "react-i18next";
import { socialMediaTypes } from "../../enum/socialMediaType";

import SocialMeidaModel from "../../Models/SocialMeidaModel";
import { indexStore } from "../../store/indexStore";

function SocialMedia(props: { social: SocialMeidaModel[] }) {
  const { t } = useTranslation();
  
  const renderSocialMedia = (e: SocialMeidaModel, i: number) => {
    let url = e.value;
    if (!url.startsWith("https://") && !url.startsWith("http://")) {
      url = "https://" + url;
    }

    return (
      <a
        key={e.id || i}
        href={url}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors group"
      >
        <div className="flex-shrink-0 p-2 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors">
          <div className="text-primary">
            {socialMediaTypes[e.type]}
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-base font-medium text-foreground group-hover:text-primary transition-colors break-words">
            {e.name}
          </p>
        </div>
        <svg
          className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
          />
        </svg>
      </a>
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-bold text-foreground border-b border-border pb-2">
        {t("gloabl.connectUs")}
      </h3>
      <div className="flex flex-col gap-2">
        <Iterator data={props.social} render={renderSocialMedia} />
      </div>
    </div>
  );
}

export default SocialMedia;
